/**
 * The Arcadia controlled code types
 *
 * The values within this enum match the Arcadia ontology labels of type "CodeSystem".
 */
export enum CodeSystem {
  ACG = 'acg',
  CDPS = 'cdps',
  CPT = 'cpt',
  DICOM = 'dicom',
  HCC = 'hcc',
  HHSHCC = 'hhshcc',
  ICD10 = 'icd10',
  ICD9 = 'icd9',
  LOINC = 'loinc',
  MDC = 'mdc',
  NDC = 'ndc',
  NUCC = 'nucc',
  RXNORM = 'rxnorm',
  SNOMED = 'snomed',
  UCUM = 'ucum',
}
